const getFlatNodesListFromParent = (parent, gltf ) => {
	return parent.children.flatMap((child) => {
		const node = gltf.nodes[child.name];
		return [node].concat(getFlatNodesListFromParent(node, gltf));
	});
};

const MAT_MAPS = ["alphaMap", "aoMap", "bumpMap", "displacementMap", "emissiveMap", "lightMap", "map", "metalnessMap", "normalMap", "roughnessMap"];

export const printGltfSceneStructure = (gltf) => {
	const stringifyStructure = (parent, str, level) => {
		return parent.children.reduce((res, child) => {
			res += `${new Array(level + 1).fill("\t").join("")}${child.name} (${child.type})${child.isMesh ? ` [m=${child.material?.name}]` : "" }\n`;
			return child.children?.length ? stringifyStructure(child, res, level + 1) : res;
		}, str || "scene:\n");
	};

	console.log(`
Structure: 
${stringifyStructure(gltf.scene, null, 0)}	
----------

Materials
${Object.entries(gltf.materials)
		.map(([name, mat]) => 
`- ${name}(${mat.name}):
	${MAT_MAPS.map((mm) => mat[mm] ? mm + ": ✔️" : null)
			.filter(Boolean)
			.join("\n\t")}
		`).join("\n")			
		}
		`);
};

//inspired by: https://github.com/KhronosGroup/glTF-Sample-Viewer/blob/main/source/GltfView/gltf_view.js#L90
const gatherSceneInfo = (gltf, scene, index) => {
	let info = undefined;

	if (scene) {
		info = {
			title: `scene-${index+1}`
		};

		const meshes = [];
		let sceneMaterials = [];

		scene.traverse((node) => {
			if (node.isMesh) {
				meshes.push(node);
				sceneMaterials = sceneMaterials.concat(node.material);
			}
		});

		const transparentMaterials = sceneMaterials.filter(({ opaque, transparent }) => transparent || opaque === 0);
		const opaqueMaterials = sceneMaterials.filter((material) => !transparentMaterials.includes(material));

		const faceCount = meshes.reduce((res, mesh) => {
			const { geometry } = mesh;

			return res +
				((geometry.index ? geometry.index.count : geometry.attributes.position.count) / 3);
		}, 0);

		info.mesh = meshes.length;
		info.face = faceCount;
		info["opaque materials"] = opaqueMaterials.length;
		info["transparent materials"] = transparentMaterials.length;
	}

	return info;
};

export const getGltfScenesInfo = (gltf) => {
	return gltf.scenes
		.map((scene, index) =>
			gatherSceneInfo(gltf, scene, index)
		)
		.filter(Boolean);
}

export const getGltfMetadata = (gltf) => {
	return {
		version: gltf.asset?.version ? `'${gltf.asset?.version}'` : "n/a",
		...gltf.asset?.extras,
		generator: gltf.asset?.generator || "n/a",
	}
};

export const findMeshInGltf = (gltf, path) =>{
	const paths = Array.isArray(path) ? [].concat(path) : path.split(".");
	const parent = gltf.scene;

	const find = (parent, paths) => {
		const name = paths.splice(0, 1)[0];
		let mesh;

		if (!isNaN(name)) {
			//support index syntax
			const index = parseInt(name);
			mesh = parent.children[index];
		} else {
			mesh = parent.children.find((c) => c.name === name);
		}

		return paths.length ? (mesh ? find(mesh, paths) : undefined): mesh;
	};

	return find(parent, paths);
};
